/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('gt/ctv/filtres', {
    state: {
        activeCheckboxes: 0,
        enableUrlParams: false,
        get hasActiveFilters() {
            return state.activeCheckboxes > 0;
        },
        get showResetButton() {
            return state.activeCheckboxes > 0;
        }
    },
    actions: {
        init: () => {
            try {
                const context = getContext();
                if (context && context.enableUrlParams !== undefined) {
                    state.enableUrlParams = context.enableUrlParams;
                }
            } catch (err) {
                // Si getContext() échoue, on garde la valeur par défaut (false)
            }
        },
        sortHeberg: (e) => {
            const element = getElement();
            const sortOrder = element.ref.value;
            let enableUrlParams = state.enableUrlParams;

            if (enableUrlParams === false || enableUrlParams === undefined) {
                try {
                    const context = getContext();
                    if (context && context.enableUrlParams !== undefined) {
                        enableUrlParams = context.enableUrlParams;
                        state.enableUrlParams = enableUrlParams;
                    }
                } catch (err) {
                    enableUrlParams = false;
                }
            }

            store('gt/ctv').state.sort_order = sortOrder;

            if (enableUrlParams) {
                setTimeout(() => {
                    store('gt/ctv/filtres').actions.updateUrlParams();
                }, 50);
            }

            // Fonction pour obtenir le statut de disponibilité d'un hébergement
            const getStatutOrder = (hebergement) => {
                const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                if (!dispoBlock) return 3; // Indisponible par défaut
                const statut = dispoBlock.getAttribute('data-gt-statut');
                // Ordre : disponible (1), contreproposition (2), indisponible (3)
                if (statut === 'disponible') return 1;
                if (statut === 'contreproposition') return 2;
                return 3; // indisponible
            };

            document.querySelectorAll('.wp-block-post-template')
            .forEach(container => {
                const hebergements = [...container.querySelectorAll('.hebergement')];

                hebergements.sort((a, b) => {
                    // D'abord trier par statut de disponibilité
                    const statutA = getStatutOrder(a);
                    const statutB = getStatutOrder(b);
                    
                    if (statutA !== statutB) {
                        return statutA - statutB;
                    }
                    
                    // Si même statut, trier par prix
                    const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                    const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;

                    return sortOrder === 'asc' ? priceA - priceB : priceB - priceA;
                });

                const fragment = document.createDocumentFragment();
                hebergements.forEach(hebergement => fragment.appendChild(hebergement));
                container.appendChild(fragment);
            });
        },
        runFilters: (e) => {
            const ctv = store("gt/ctv");
            let enableUrlParams = state.enableUrlParams;

            if (enableUrlParams === false || enableUrlParams === undefined) {
                try {
                    const context = getContext();
                    if (context && context.enableUrlParams !== undefined) {
                        enableUrlParams = context.enableUrlParams;
                        state.enableUrlParams = enableUrlParams;
                    }
                } catch (err) {
                    enableUrlParams = false;
                }
            }
        
            if (e !== undefined && e.type !== "load") {

                // Find the container of the clicked filter
                let filterContainer = e.target.closest('.gt-hebergements-filtre');

                // Gestion spécifique pour le filtre "types" :
                // permettre de passer directement de "Locatif" à "Emplacement" (et inversement)
                // sans devoir repasser par "Tous" ni décocher manuellement.
                const filterNameAttr = filterContainer?.getAttribute('data-gt-filtre-name');
                const clickedValue = e.target?.value;
                if (filterNameAttr === 'types' && clickedValue !== undefined && clickedValue !== '') {
                    const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach((checkbox) => {
                        if (checkbox === e.target) {
                            checkbox.checked = true;
                        } else {
                            // On ne laisse coché que la case cliquée, pas "Tous" ni les autres types.
                            checkbox.checked = false;
                        }
                    });
                }
        
                // Check/uncheck "All" checkbox based on individual selections
                let allCheckbox = filterContainer.querySelector('input[value=""]');
                let allChecked = filterContainer.querySelectorAll('input:checked:not([value=""])');
                if (allCheckbox) {
                    allCheckbox.checked = allChecked.length === 0;
                }
        
                // Store selected filter values in cookies uniquement pour le type (gtType)
                let cookieName = filterContainer.getAttribute('data-gt-cookie');
                if (cookieName === 'gtType') {
                    let cookieValue = Array.from(allChecked).map(checkbox => checkbox.value);
                    Cookies.set(cookieName, cookieValue);
                }
            }
        
            // Initialize the filters object and count of active filters
            let filters = {};
            let activeFilterCount = 0;
        
            // Loop over all active filters and collect the checked values
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let operator = activeFilterContainer.getAttribute('data-gt-filtre-operator') || 'OR'; // Default to "OR" operator
        
                if (filterName) {
                    let selectedValues = Array.from(activeFilterContainer.querySelectorAll('input:checked:not([value=""])'))
                        .map(input => input.value);
        
                    // Only add filters with selected values to the filters object
                    if (selectedValues.length > 0) {
                        filters[filterName] = {
                            values: selectedValues,
                            operator: operator
                        };
                        activeFilterCount++; // Count active filters with at least one checked value
                    }
                }
            });

            state.activeCheckboxes = document.querySelectorAll('.gt-hebergements-filtre input:checked:not([value=""])').length;

            // En V2, sans paramètres de dates dans l'URL, on doit afficher tous les hébergements.
            // On ne masque donc pas les éléments "indisponible" dans la logique des filtres front.
            const searchParams = new URLSearchParams(window.location.search);
            const hasArrivalParam = !!searchParams.get('arrival');
            const hasDepartureParam = !!searchParams.get('departure');
            const hasV2QueryOnPage = !!document.querySelector('.gt-ws-ctv-hebergements-query-v2');
            const keepIndisponiblesVisible = hasV2QueryOnPage && !(hasArrivalParam && hasDepartureParam);
            
            // Masquer/afficher les boutons de réinitialisation selon le nombre de filtres actifs
            const resetButtons = document.querySelectorAll('.gt-hebergements-reset-button-wrapper, .gt-hebergements-filtres__reset-button');
            resetButtons.forEach(button => {
                if (state.activeCheckboxes > 0) {
                    button.style.display = '';
                } else {
                    button.style.display = 'none';
                }
            });
                
            // Hide/show each hebergement based on the selected filters
            let visibleHebergements = [];
            // Sélecteur amélioré pour trouver les hébergements : soit .hebergement, soit les <li> avec les attributs data-gt-*
            // Inclure aussi la variation V2 (gt-ws-ctv-hebergements-query-v2) sans casser la V1.
            document.querySelectorAll('.gt-ws-ctv-hebergements-query .hebergement, .gt-ws-ctv-hebergements-query-v2 .hebergement, .gt-ws-ctv-disponibilites-query .hebergement, .gt-ws-ctv-indisponibles-query .hebergement, .gt-ws-ctv-hebergements-query li[data-gt-camping], .gt-ws-ctv-hebergements-query-v2 li[data-gt-camping], .gt-ws-ctv-disponibilites-query li[data-gt-camping], .gt-ws-ctv-indisponibles-query li[data-gt-camping]').forEach(hebergement => {
                let shouldShow = true;
        
                // Hide hebergement if it has data-gt-statut="indisponible"
                const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                if (!keepIndisponiblesVisible && dispoBlock && dispoBlock.getAttribute('data-gt-statut') === 'indisponible') {
                    shouldShow = false;
                }
                else{
                    // Check each filter against the data attributes of the hebergement
                    Object.keys(filters).forEach(filterName => {
                        let dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);

                        // Pour les emplacements : ignorer complètement la notion de chambres dans le filtrage.
                        // Donc le filtre "rooms" ne s'applique pas aux hébergements dont le type contient "emplacement".
                        if (filterName === 'rooms') {
                            const typesAttr = hebergement.getAttribute('data-gt-types') || '';
                            if (typesAttr.toLowerCase().indexOf('emplacement') !== -1) {
                                return; // on ne modifie pas shouldShow pour ce filtre
                            }
                        }
            
                        // Si l'attribut existe et n'est pas vide, on vérifie le filtre
                        if (dataAttribute && dataAttribute.trim() !== '') {
                            // Convert the data-attribute value into an array if it's a string
                            let dataValues = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];

                            dataValues = dataValues.map(value => value.replace(/\[|\]/g, '').trim()).filter(value => value !== '');

                            let filter = filters[filterName];
                            let { values, operator } = filter;
            
                            let matches = false;
                            switch (operator) {
                                case 'AND':
                                // Sélectionne le filtre actif correspondant au nom spécifié
                                let activeFilter = document.querySelector(`.gt-hebergements-filtre[data-gt-filtre-name="${filterName}"]`);
                                
                                if (!activeFilter) {
                                    matches = false;
                                    break;
                                }
                                
                                // Récupérer les clés "provided only" depuis data-gt-provided-only
                                const providedOnlyAttr = activeFilter.getAttribute('data-gt-provided-only') || '';
                                const providedOnlyKeys = providedOnlyAttr ? providedOnlyAttr.split(',').map(v => v.trim()).filter(v => v !== '') : [];

                                // Récupérer data-gt-options-provided de l'hébergement
                                const providedAttr = hebergement.getAttribute('data-gt-options-provided') || '';
                                const providedValues = providedAttr
                                    ? providedAttr.replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '')
                                    : [];

                                // Crée un tableau `allValues` à partir de tous les inputs cochés dans le filtre actif, sauf ceux ayant une valeur vide
                                let allValues = Array.from(activeFilter.querySelectorAll('input:checked:not([value=""])'))
                                    .map(checkbox => {
                                        // Divise la valeur de chaque input par des virgules pour obtenir un tableau de valeurs
                                        let values = checkbox.value.split(',').map(v => v.trim()).filter(v => v !== '');

                                        // Retourne un objet indiquant s'il faut utiliser `some` (si plusieurs valeurs) ou `every` (si une seule valeur)
                                        return values.length > 1 ? { type: 'some', values } : { type: 'every', values };
                                    });

                                // Évalue si l'hébergement doit correspondre en fonction du type de comparaison requis (`some` ou `every`)
                                // CTOUTVERT peut avoir plusieur code d'option en fonction de la catégorie de l'hébergement (ex: wifi pictch ou wifi location)
                                matches = allValues.length > 0 && allValues.every(item => {
                                    // Pour les clés "provided only", vérifier dans data-gt-options-provided
                                    const isProvidedOnly = item.values.some(v => providedOnlyKeys.includes(v));
                                    const checkIn = isProvidedOnly ? providedValues : dataValues;

                                    if (item.type === 'some') {
                                        return item.values.some(value => checkIn.includes(value));
                                    } else {
                                        return item.values.every(value => checkIn.includes(value));
                                    }
                                });

                                break;


                                case '<=':
                                    // Match if all dataValues are less than or equal to filter values (assuming numerical comparison)
                                    matches = dataValues.length > 0 && values.every(value => parseInt(dataValues[0]) <= parseInt(value));
                                    break;
                                case '>=':
                                    // Match if all dataValues are greater than or equal to filter values (assuming numerical comparison)
                                    matches = dataValues.length > 0 && values.every(value => parseInt(dataValues[0]) >= parseInt(value));
                                    break;
                                case 'OR':
                                default:
                                    // Match if any filter value is present in dataValues (default behavior)
                                    matches = dataValues.length > 0 && values.some(value => dataValues.includes(value));
                                    break;
                            }
            
                            if (!matches) {
                                shouldShow = false;
                            }
                        } else if (filters[filterName].values.length > 0) {
                            // Si l'attribut n'existe pas ou est vide mais qu'un filtre est sélectionné, on cache l'hébergement
                            shouldShow = false;
                        }
                    });
                }
        
                // Toggle visibility based on the filter match
                if (shouldShow) {
                    hebergement.style.display = '';
                    visibleHebergements.push(hebergement); // Track visible hebergements
                } else {
                    hebergement.style.display = 'none';
                }
            });
        
            // Collecter tous les hébergements disponibles (indépendamment des filtres options)
            // pour pouvoir calculer quelles options sont activables même quand options est le seul filtre actif
            const allAvailableHebergements = Array.from(
                document.querySelectorAll(
                    '.gt-ws-ctv-hebergements-query .hebergement, .gt-ws-ctv-hebergements-query-v2 .hebergement, .gt-ws-ctv-disponibilites-query .hebergement, .gt-ws-ctv-indisponibles-query .hebergement, .gt-ws-ctv-hebergements-query li[data-gt-camping], .gt-ws-ctv-hebergements-query-v2 li[data-gt-camping], .gt-ws-ctv-disponibilites-query li[data-gt-camping], .gt-ws-ctv-indisponibles-query li[data-gt-camping]'
                )
            ).filter(hebergement => {
                const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                return keepIndisponiblesVisible || !(dispoBlock && dispoBlock.getAttribute('data-gt-statut') === 'indisponible');
            });

            // Pour le filtre "rooms" : hébergements visibles en ignorant le filtre chambres,
            // afin de garder plusieurs options chambres activables (choix multiple) quand elles existent pour le type choisi
            const hebergementSelector = '.gt-ws-ctv-hebergements-query .hebergement, .gt-ws-ctv-hebergements-query-v2 .hebergement, .gt-ws-ctv-disponibilites-query .hebergement, .gt-ws-ctv-indisponibles-query .hebergement, .gt-ws-ctv-hebergements-query li[data-gt-camping], .gt-ws-ctv-hebergements-query-v2 li[data-gt-camping], .gt-ws-ctv-disponibilites-query li[data-gt-camping], .gt-ws-ctv-indisponibles-query li[data-gt-camping]';
            let hebergementsVisibleWithoutRooms = [];
            if (Object.prototype.hasOwnProperty.call(filters, 'rooms')) {
                document.querySelectorAll(hebergementSelector).forEach(hebergement => {
                    const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                    if (!keepIndisponiblesVisible && dispoBlock && dispoBlock.getAttribute('data-gt-statut') === 'indisponible') return;
                    let shouldShow = true;
                    Object.keys(filters).forEach(filterName => {
                        if (filterName === 'rooms') return;
                        const dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);
                        if (dataAttribute && dataAttribute.trim() !== '') {
                            let dataValues = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];
                            dataValues = dataValues.map(v => v.replace(/\[|\]/g, '').trim()).filter(v => v !== '');
                            const filter = filters[filterName];
                            const { values, operator } = filter;
                            let matches = false;
                            if (operator === 'AND') {
                                const activeFilter = document.querySelector(`.gt-hebergements-filtre[data-gt-filtre-name="${filterName}"]`);
                                if (!activeFilter) { matches = false; }
                                else {
                                    const providedOnlyAttr = activeFilter.getAttribute('data-gt-provided-only') || '';
                                    const providedOnlyKeys = providedOnlyAttr ? providedOnlyAttr.split(',').map(v => v.trim()).filter(v => v !== '') : [];
                                    const providedAttr = hebergement.getAttribute('data-gt-options-provided') || '';
                                    const providedValues = providedAttr ? providedAttr.replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '') : [];
                                    const dataAttr = hebergement.getAttribute(`data-gt-${filterName}`);
                                    const allDataValues = dataAttr ? dataAttr.replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '') : [];
                                    const allValues = Array.from(activeFilter.querySelectorAll('input:checked:not([value=""])')).map(cb => {
                                        const vals = cb.value.split(',').map(v => v.trim()).filter(v => v !== '');
                                        return vals.length > 1 ? { type: 'some', values: vals } : { type: 'every', values: vals };
                                    });
                                    matches = allValues.length > 0 && allValues.every(item => {
                                        const checkIn = item.values.some(v => providedOnlyKeys.includes(v)) ? providedValues : allDataValues;
                                        return item.type === 'some' ? item.values.some(v => checkIn.includes(v)) : item.values.every(v => checkIn.includes(v));
                                    });
                                }
                            } else if (operator === '<=') {
                                matches = dataValues.length > 0 && values.every(v => parseInt(dataValues[0]) <= parseInt(v));
                            } else if (operator === '>=') {
                                matches = dataValues.length > 0 && values.every(v => parseInt(dataValues[0]) >= parseInt(v));
                            } else {
                                matches = dataValues.length > 0 && values.some(v => dataValues.includes(v));
                            }
                            if (!matches) shouldShow = false;
                        } else if (filters[filterName].values.length > 0) {
                            shouldShow = false;
                        }
                    });
                    if (shouldShow) hebergementsVisibleWithoutRooms.push(hebergement);
                });
            }

            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let filterOperator = activeFilterContainer.getAttribute('data-gt-filtre-operator') || 'OR';

                // Récupérer les clés "provided only" depuis data-gt-provided-only
                const containerProvidedOnlyAttr = activeFilterContainer.getAttribute('data-gt-provided-only') || '';
                const containerProvidedOnlyKeys = containerProvidedOnlyAttr
                    ? containerProvidedOnlyAttr.split(',').map(v => v.trim()).filter(v => v !== '')
                    : [];
            
                let selectedCheckboxes = activeFilterContainer.querySelectorAll('input:checked:not([value=""])');
                let activeFilterCount = document.querySelectorAll('.gt-hebergements-filtre input:checked:not([value=""])').length;
                let isSingleActiveFilter = selectedCheckboxes.length > 0 && activeFilterCount === selectedCheckboxes.length;
            
                activeFilterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    let checkboxValues = checkbox.value.split(',').map(v => v.trim()).filter(v => v !== '');
                    if (checkbox.value === '') return; // Ne pas désactiver "Tous"
            
                    let shouldEnable = false;
                    let isChecked = checkbox.checked;

                    if (filterOperator === 'AND') {
                        // Pour le filtre options (AND) : simuler si l'ajout de CETTE checkbox
                        // (en plus des options déjà cochées) donnerait au moins un hébergement disponible.
                        // On scanne toujours allAvailableHebergements (non filtrés par les options)
                        // mais on vérifie que l'hébergement possède TOUTES les options cochées + celle-ci.

                        // Collecter les valeurs des autres options déjà cochées dans ce filtre
                        const alreadyCheckedValues = Array.from(
                            activeFilterContainer.querySelectorAll('input:checked:not([value=""])')
                        )
                        .filter(cb => cb !== checkbox)
                        .map(cb => cb.value.split(',').map(v => v.trim()).filter(v => v !== ''));

                        // Pour vérifier la combinaison options + autres filtres actifs,
                        // on filtre allAvailableHebergements par les autres filtres actifs (non-options)
                        const otherFilters = Object.keys(filters).filter(fn => fn !== filterName);
                        const basePool = allAvailableHebergements.filter(hebergement => {
                            return otherFilters.every(fn => {
                                const attr = hebergement.getAttribute(`data-gt-${fn}`);
                                if (!attr || attr.trim() === '') return false;
                                const vals = attr.replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '');
                                return filters[fn].values.some(v => vals.includes(v));
                            });
                        });

                        const poolToCheck = otherFilters.length > 0 ? basePool : allAvailableHebergements;

                        poolToCheck.forEach(hebergement => {
                            if (shouldEnable) return;

                            const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                            if (!keepIndisponiblesVisible && dispoBlock && dispoBlock.getAttribute('data-gt-statut') === 'indisponible') return;

                            const dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);
                            const providedAttr = hebergement.getAttribute('data-gt-options-provided') || '';
                            const providedValues = providedAttr
                                .replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '');
                            const allDataValues = dataAttribute
                                ? dataAttribute.replace(/\[|\]/g, '').split(',').map(v => v.trim()).filter(v => v !== '')
                                : [];

                            // Vérifier que cet hébergement possède cette checkbox
                            const thisCheckboxMatches = checkboxValues.some(value => {
                                const isProvidedOnly = containerProvidedOnlyKeys.includes(value);
                                const checkIn = isProvidedOnly ? providedValues : allDataValues;
                                return checkIn.includes(value);
                            });

                            if (!thisCheckboxMatches) return;

                            // Vérifier que cet hébergement possède aussi toutes les autres options déjà cochées
                            const allOtherMatch = alreadyCheckedValues.every(vals => {
                                return vals.some(value => {
                                    const isProvidedOnly = containerProvidedOnlyKeys.includes(value);
                                    const checkIn = isProvidedOnly ? providedValues : allDataValues;
                                    return checkIn.includes(value);
                                });
                            });

                            if (allOtherMatch) shouldEnable = true;
                        });
                    } else {
                        // Pour les filtres OR : si ce filtre est le seul actif, toutes ses cases sont activables
                        if (isSingleActiveFilter) {
                            shouldEnable = true;
                        } else {
                            // Pour "rooms" : utiliser les hébergements visibles SANS le filtre chambres pour garder le choix multiple (1 et 3 ch. activables)
                            const pool = (filterName === 'rooms' && hebergementsVisibleWithoutRooms.length > 0)
                                ? hebergementsVisibleWithoutRooms
                                : visibleHebergements;
                            pool.forEach(hebergement => {
                                if (shouldEnable) return;

                                const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                                if (!keepIndisponiblesVisible && dispoBlock && dispoBlock.getAttribute('data-gt-statut') === 'indisponible') return;

                                // Pour le filtre rooms : ignorer les emplacements (ils n'ont pas de "chambres" à proposer)
                                if (filterName === 'rooms') {
                                    const typesAttr = hebergement.getAttribute('data-gt-types') || '';
                                    if (typesAttr.toLowerCase().indexOf('emplacement') !== -1) return;
                                }

                                const dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);
                                if (dataAttribute) {
                                    const dataValues = dataAttribute.split(',').map(value => value.replace(/\[|\]/g, '').trim());
                                    if (checkboxValues.some(value => dataValues.includes(value))) {
                                        shouldEnable = true;
                                    }
                                }
                            });
                        }
                    }

                    // Filtre "types" : ne jamais désactiver pour pouvoir changer d’un type à l’autre sans repasser par "Tous".
                    // "rooms" : on désactive les options non disponibles (ex. si le type choisi n’a pas de 2 ch., "2 ch." reste non sélectionnable).
                    const neverDisableFilters = ['types'];
                    if (neverDisableFilters.includes(filterName)) {
                        checkbox.disabled = false;
                    } else {
                        // ✅ Désactiver si aucun hébergement visible ne correspond, sauf si déjà coché
                        checkbox.disabled = !shouldEnable && !isChecked;
                    }
                });
            });
            
            
        

            
            // Hide contreproposition if no hebergements are visible
            let disponibilites = document.querySelectorAll('.gt-ws-ctv-disponibilites-query');
            if (disponibilites) {
                disponibilites.forEach(disponibilite => {
                    let visibleInDisponibilites = disponibilite.querySelectorAll('.hebergement:not([style*="display: none"])').length;
                    let noResults = disponibilite.querySelectorAll('.wp-block-query-no-results').length;
                    if (visibleInDisponibilites === 0 && noResults === 0) {
                        // disponibilite.classList.add('gt-ws-ctv-no-filter-results');
                        const noResultsElement = disponibilite.querySelector('.wp-block-gt-gt-ws-ctv-product-no-results');
                        if (noResultsElement) {
                            noResultsElement.style.display = 'block';
                            noResultsElement.removeAttribute('hidden');
                        }
                    } else {
                        // disponibilite.classList.remove('gt-ws-ctv-no-filter-results');
                        const noResultsElement = disponibilite.querySelector('.wp-block-gt-gt-ws-ctv-product-no-results');
                        if (noResultsElement && !noResultsElement.closest('.wp-block-query-no-results')) {
                            noResultsElement.style.display = 'none';
                            noResultsElement.setAttribute('hidden', 'true');
                        }
                    }
                });
            }

            // Hide indisponibles if no hebergements are visible
            let indisponibles = document.querySelectorAll('.gt-ws-ctv-indisponibles-query');
            if (indisponibles) {
                indisponibles.forEach(indisponible => {
                    let visibleInIndisponibles = indisponible.querySelectorAll('.hebergement:not([style*="display: none"])').length;
                    if (visibleInIndisponibles === 0) {
                        indisponible.classList.add('gt-ws-ctv-no-filter-results');
                    } else {
                        indisponible.classList.remove('gt-ws-ctv-no-filter-results');
                    }
                });
            }

            // Message "aucun résultat" pour la liste principale quand les filtres cachent tout
            const mainQueryEl = document.querySelector('.gt-ws-ctv-hebergements-query, .gt-ws-ctv-hebergements-query-v2');
            if (mainQueryEl) {
                const visibleInMain = mainQueryEl.querySelectorAll('.hebergement:not([style*="display: none"]), li[data-gt-camping]:not([style*="display: none"])').length;
                const filtresEl = document.querySelector('[data-gt-no-results-message]');
                const message = filtresEl ? filtresEl.getAttribute('data-gt-no-results-message') : 'Aucun hébergement ne correspond à votre recherche.';
                const resetLabel = filtresEl ? filtresEl.getAttribute('data-gt-reset-filters-label') : 'Réinitialisez les filtres';
                let noResultsEl = mainQueryEl.querySelector('.gt-ws-ctv-main-filter-no-results');
                if (visibleInMain === 0) {
                    if (!noResultsEl) {
                        noResultsEl = document.createElement('div');
                        noResultsEl.className = 'gt-ws-ctv-main-filter-no-results wp-block-gt-gt-ws-ctv-product-no-results';
                        noResultsEl.setAttribute('data-wp-interactive', 'gt/ctv/filtres');
                        noResultsEl.innerHTML = '<p class="gt-ws-ctv-product-no-results__message"></p><button type="button" class="gt-ws-ctv-product-no-results__reset"><i class="fas fa-undo-alt"></i> <span class="gt-ws-ctv-product-no-results__reset-label"></span></button>';
                        const btn = noResultsEl.querySelector('button');
                        if (btn) {
                            btn.addEventListener('click', () => store('gt/ctv/filtres').actions.clearAllFilters());
                        }
                        mainQueryEl.appendChild(noResultsEl);
                    }
                    const msgEl = noResultsEl.querySelector('.gt-ws-ctv-product-no-results__message');
                    const labelEl = noResultsEl.querySelector('.gt-ws-ctv-product-no-results__reset-label');
                    if (msgEl) msgEl.innerHTML = message.replace( /\n/g, '<br>' );
                    if (labelEl) labelEl.textContent = resetLabel;
                    noResultsEl.style.display = '';
                    noResultsEl.removeAttribute('hidden');
                } else {
                    if (noResultsEl) {
                        noResultsEl.style.display = 'none';
                        noResultsEl.setAttribute('hidden', '');
                    }
                }
            }

            // Execute the submission with the current state
            // ctv.actions.submitForm();

            // Mettre à jour l'URL si activé
            if (enableUrlParams) {
                setTimeout(() => {
                    store('gt/ctv/filtres').actions.updateUrlParams();
                }, 100);
            }

        },        
        clearFilter: (e) => {
            const ctv = store("gt/ctv");
            let checkboxes = e.target.closest('.gt-hebergements-filtre').querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            e.target.checked = true;

            let cookieName = e.target.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
            if (cookieName) {
                Cookies.set(cookieName, []);
                ctv.state[cookieName] = [];
            }

            store('gt/ctv/filtres').actions.runFilters(e);

            // ctv.actions.submitForm();
        },
        clearAllFilters: (e) => {
            const ctv = store("gt/ctv");
            let checkboxes = document.querySelectorAll('.gt-hebergements-filtre input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = checkbox.value != "" ? false : true;

                let cookieName = checkbox.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
                if (cookieName) {
                    Cookies.set(cookieName, []);
                    ctv.state[cookieName] = [];
                }

            });




            // let cookiesNames = document.querySelectorAll('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
            // cookiesNames.forEach(cookieName => {
            //     if (cookieName) {
            //         Cookies.set(cookieName, []);
            //         ctv.state[cookieName] = [];
            //     }
            // });

            store('gt/ctv/filtres').actions.runFilters();
            
            // Masquer les boutons de réinitialisation après avoir réinitialisé
            const resetButtons = document.querySelectorAll('.gt-hebergements-reset-button-wrapper, .gt-hebergements-filtres__reset-button');
            resetButtons.forEach(button => {
                button.style.display = 'none';
            });

            // Mettre à jour l'URL si activé
            let enableUrlParamsClear = state.enableUrlParams;
            if (enableUrlParamsClear === false || enableUrlParamsClear === undefined) {
                try {
                    const context = getContext();
                    if (context && context.enableUrlParams !== undefined) {
                        enableUrlParamsClear = context.enableUrlParams;
                        state.enableUrlParams = enableUrlParamsClear;
                    }
                } catch (err) {
                    enableUrlParamsClear = false;
                }
            }
            if (enableUrlParamsClear) {
                setTimeout(() => {
                    store('gt/ctv/filtres').actions.updateUrlParams();
                }, 50);
            }

        },
        toggleSidebar: (e) => {
            const context = getContext();
            context.isSidebarOpen = !context.isSidebarOpen;

            document.body.classList.toggle('gt-ws-sidebar-toggled');

            // let sidebar = document.querySelector('.gt-hebergements-filtres__sidebar');

            // if(!sidebar) return;
            // sidebar.classList.toggle('gt-hebergements-filtres__sidebar--opened');

            // if(sidebar.classList.contains('gt-hebergements-filtres__sidebar--opened')){
            //     sidebar.setAttribute('aria-expanded', 'true');
            // }
            // else{
            //     sidebar.setAttribute('aria-expanded', 'false');
            // }

        },
        toggleFilter: (e) => {
            const context = getContext();
            if(!context.isAccordeon) return;

            let filter = e.target.closest('.gt-hebergements-filtre');
            filter.classList.toggle('closed');

            if(filter.classList.contains('closed')){
                filter.setAttribute('aria-expanded', 'false');
            }
            else{
                filter.setAttribute('aria-expanded', 'true');
            }

        },
        handleKeydown: (e) => {
            if (e.key === 'Escape') {
                store('gt/ctv/filtres').actions.toggleSidebar(e);
            }

            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const sidebar = document.querySelector('.gt-hebergements-filtres__sidebar');
            const firstFocusableElement = sidebar.querySelectorAll(focusableElements)[0];
            const focusableContent = sidebar.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        },
        stickButton: (e) => {
            const element = getElement();
            const scrollTop = window.scrollY;
            const actionsBottom = element.ref.getBoundingClientRect().bottom + window.scrollY;
            const height = element.ref.offsetHeight;
            element.ref.querySelector('.gt-hebergements-actions-placeholder').style.height = `${height}px`;

            if (scrollTop > actionsBottom) {
                state.filterButtonSticked = true;
            } else {
                state.filterButtonSticked = false;
            }
        },
        closeFiltersOnOutsideClick: (e) => {
            const context = getContext();
            if(!context.isAccordeon) return;

            // Vérifier tous les conteneurs gt-hebergements-filtres
            const filtersContainers = document.querySelectorAll('.gt-hebergements-filtres');
            if (!filtersContainers.length) return;

            // Vérifier si le clic est à l'intérieur d'un des conteneurs
            let isInsideContainer = false;
            filtersContainers.forEach(container => {
                if (container.contains(e.target)) {
                    isInsideContainer = true;
                }
            });

            // Si le clic est en dehors de tous les conteneurs, fermer tous les filtres
            if (!isInsideContainer) {
                filtersContainers.forEach(container => {
                    container.querySelectorAll('.gt-hebergements-filtre:not(.closed)').forEach(filter => {
                        filter.classList.add('closed');
                        filter.setAttribute('aria-expanded', 'false');
                    });
                });
                return;
            }

            // Si le clic est dans un conteneur, vérifier chaque filtre ouvert individuellement
            filtersContainers.forEach(container => {
                container.querySelectorAll('.gt-hebergements-filtre:not(.closed)').forEach(filter => {
                    // Vérifier si le clic est à l'intérieur de ce filtre spécifique
                    if (!filter.contains(e.target)) {
                        // Le clic est en dehors de ce filtre, le fermer
                        filter.classList.add('closed');
                        filter.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        },
        updateUrlParams: () => {
            let enableUrlParams = state.enableUrlParams;

            if (enableUrlParams === false || enableUrlParams === undefined) {
                try {
                    const context = getContext();
                    if (context && context.enableUrlParams !== undefined) {
                        enableUrlParams = context.enableUrlParams;
                        state.enableUrlParams = enableUrlParams;
                    }
                } catch (e) {
                    enableUrlParams = state.enableUrlParams || false;
                }
            }

            if (!enableUrlParams) {
                return;
            }

            const url = new URL(window.location.href);

            // Mapping des noms de filtres vers les paramètres URL
            const filterToUrlParam = {
                'camping':     'campings',
                'types':       'types',
                'gammes':      'gammes',
                'taxo-custom': 'taxo_custom',
                'rooms':       'rooms',
                'capacity':    'capacity',
                'bathrooms':   'bathrooms',
                'options':     'options'
            };

            const activeFilters = {};

            document.querySelectorAll('.gt-hebergements-filtre').forEach(filterContainer => {
                const filterName = filterContainer.getAttribute('data-gt-filtre-name');
                const urlParamName = filterToUrlParam[filterName];

                if (urlParamName) {
                    const checkedInputs = Array.from(filterContainer.querySelectorAll('input:checked:not([value=""])'));

                    if (checkedInputs.length > 0) {
                        // Pour les gammes et taxo_custom, utiliser les slugs
                        if (filterName === 'gammes' || filterName === 'taxo-custom') {
                            const slugs = checkedInputs
                                .map(input => {
                                    const slug = input.getAttribute('data-slug');
                                    return slug || input.value;
                                })
                                .filter(slug => slug);

                            if (slugs.length > 0) {
                                activeFilters[urlParamName] = slugs;
                            } else {
                                url.searchParams.delete(urlParamName);
                            }
                        } else {
                            const values = checkedInputs.map(input => input.value);
                            activeFilters[urlParamName] = values;
                        }
                    } else {
                        url.searchParams.delete(urlParamName);
                    }
                }
            });

            Object.keys(activeFilters).forEach(paramName => {
                const values = activeFilters[paramName];
                if (values.length > 0) {
                    url.searchParams.set(paramName, values.join(','));
                }
            });

            // Gérer le tri
            const sortInput = document.querySelector('input[name="sort"]:checked');
            if (sortInput && sortInput.value) {
                url.searchParams.set('sort', sortInput.value);
            } else {
                url.searchParams.delete('sort');
            }

            window.history.replaceState({}, '', url.toString());
        }
    }
});

// Sticky btn

// window.addEventListener('load', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     actions.style.height = `${actions.offsetHeight}px`;
// });

// window.addEventListener('load resize', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     actions.style.height = `${actions.offsetHeight}px`;
// });

// window.addEventListener('scroll', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     const scrollTop = window.scrollY;
//     const actionsBottom = actions.getBoundingClientRect().bottom + window.scrollY;

//     if (scrollTop > actionsBottom) {
//         actions.classList.add('sticked');
//     } else {
//         actions.classList.remove('sticked');
//     }
// });

// Déclencher filtres/tri initial de manière robuste (compatible delay JS/WP Rocket).
const runInitialHebergementsFilters = (attempt = 0) => {
    const hasHebergements = document.querySelector('.wp-block-post-template .hebergement');

    // Si le DOM des hébergements n'est pas encore prêt, réessayer brièvement.
    if (!hasHebergements && attempt < 20) {
        setTimeout(() => runInitialHebergementsFilters(attempt + 1), 150);
        return;
    }

    // Appliquer les filtres initiaux (cookies / pré-sélections / état CTV).
    store('gt/ctv/filtres').actions.runFilters({ type: 'load' });

    const checkedSortRadio = document.querySelector('.gt-hebergements-sort input[type="radio"]:checked');
    const hasPriceSort = !!checkedSortRadio;
    const sortOrder = hasPriceSort ? checkedSortRadio.value : null;
    if (hasPriceSort) {
        store('gt/ctv').state.sort_order = sortOrder;
    }

    const getStatutOrder = (hebergement) => {
        const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
        if (!dispoBlock) return 3;
        const statut = dispoBlock.getAttribute('data-gt-statut');
        if (statut === 'disponible') return 1;
        if (statut === 'contreproposition') return 2;
        return 3;
    };

    document.querySelectorAll('.wp-block-post-template').forEach(container => {
        const hebergements = [...container.querySelectorAll('.hebergement')];

        hebergements.sort((a, b) => {
            const statutA = getStatutOrder(a);
            const statutB = getStatutOrder(b);

            // Toujours regrouper par statut (Disponible, Disponible à d'autres dates, Indisponible)
            if (statutA !== statutB) {
                return statutA - statutB;
            }

            // Si aucun tri par prix n'est sélectionné, conserver l'ordre d'origine
            if (!hasPriceSort) {
                return 0;
            }

            const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
            const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
            return sortOrder === 'asc' ? priceA - priceB : priceB - priceA;
        });

        const fragment = document.createDocumentFragment();
        hebergements.forEach(hebergement => fragment.appendChild(hebergement));
        container.appendChild(fragment);
    });
};

/** Injecte arrival, departure, nbPers de l'URL courante dans le lien de la carte au survol (évite 302 au clic). */
const injectUrlParamsOnCardHover = () => {
    const selector = '.gt-ws-ctv-hebergements-query .hebergement, .gt-ws-ctv-hebergements-query-v2 .hebergement, .gt-ws-ctv-disponibilites-query .hebergement, .gt-ws-ctv-indisponibles-query .hebergement';
    document.querySelectorAll(selector).forEach((card) => {
        if (card.dataset.gtInjectDone) return;
        card.dataset.gtInjectDone = '1';
        card.addEventListener('mouseenter', function onEnter() {
            const link = card.querySelector('a[href*="/hebergement/"], a[href*="hebergement/"]');
            if (!link || !link.href) return;
            try {
                const cur = new URL(window.location.href);
                const arr = cur.searchParams.get('arrival');
                const dep = cur.searchParams.get('departure');
                const nb = cur.searchParams.get('nbPers');
                if (!arr || !dep) return;
                const url = new URL(link.href);
                url.searchParams.set('arrival', arr);
                url.searchParams.set('departure', dep);
                if (nb) url.searchParams.set('nbPers', nb);
                link.href = url.toString();
            } catch (e) {}
        }, { once: false });
    });
};

const scheduleInitialHebergementsFilters = () => {
    setTimeout(() => {
        runInitialHebergementsFilters(0);
        setTimeout(injectUrlParamsOnCardHover, 100);
    }, 0);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitialHebergementsFilters);
} else {
    scheduleInitialHebergementsFilters();
}

window.addEventListener('load', scheduleInitialHebergementsFilters);
window.addEventListener('gt_ws_ctv_updated', () => {
    scheduleInitialHebergementsFilters();
    setTimeout(injectUrlParamsOnCardHover, 100);
});